import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles, useTheme } from '@material-ui/styles';
import { useMediaQuery } from '@material-ui/core';

const randomCoverImagePath = (min, max) => {
  min = Math.ceil(min);
  max = Math.floor(max);
  const coverImgNumber = Math.floor(Math.random() * (max - min + 1)) + min;
  return `url(/images/cover-home-${coverImgNumber}.jpg)`;
};
const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.up('sm')]: {
      paddingTop: 0
    },
    [theme.breakpoints.down('sm')]: {
      paddingTop: 0
    }
  },
  shiftContent: {
    paddingLeft: 0,
    paddingRight: 0
  },
  content: {
    marginTop: 0
  },
  coverSection: {
    marginTop: '20px',
    backgroundImage: randomCoverImagePath(1, 3),
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center center',
    paddingTop: '163px',
    textAlign: 'center'
  },
  coverSectionTextTitle: {
    fontSize: '3.5em',
    marginBottom: '50px',
    lineHeight: '1.5em',
    padding: '15px',
    borderRadius: '45px',
    marginLeft: '36%',
    marginRight: '36%'
  },
  coverSectionTextSubDesc: {
    fontSize: '25px',
    marginRight: '2em',
    marginLeft: '2em',
    marginBottom: '2em',
    lineHeight: '1em',
    padding: '15px',
    borderRadius: '45px'
  },
  coverSectionTextSubDescMobile: {
    fontSize: '17px',
    marginRight: '2em',
    marginLeft: '2em',
    marginBottom: '2em',
    lineHeight: '1em',
    padding: '15px',
    borderRadius: '45px',
    opacity: '0.85'
  }
}));

const SecondMainPublic = (props) => {
  const { children } = props;

  const classes = useStyles();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'), {
    defaultMatches: true
  });
  return (
    <div>
      <div
        className={clsx({
          [classes.root]: true,
          [classes.shiftContent]: isDesktop
        })}>
        <main className={classes.content}>{children}</main>
      </div>
    </div>
  );
};

SecondMainPublic.propTypes = {
  children: PropTypes.node
};

export default SecondMainPublic;
